import { Chip } from '@mui/material';

interface MenuItemBadgeProps {
    label: string;
    variant: 'outlined' | 'filled' | 'soft';
}

const variantStyles: Record<
    MenuItemBadgeProps['variant'],
    { bgcolor: string; color: string; border: string; borderColor?: string }
> = {
    outlined: {
        bgcolor: 'transparent',
        color: 'primary.main',
        border: '1px solid',
        borderColor: 'primary.main',
    },
    filled: {
        bgcolor: 'primary.main',
        color: 'common.white',
        border: 'none',
    },
    soft: {
        bgcolor: 'lightPrimary.main',
        color: 'primary.main',
        border: 'none',
    },
};

export default function MenuItemBadge({ label, variant }: Readonly<MenuItemBadgeProps>) {
    const { bgcolor, color, border, borderColor } = variantStyles[variant];

    return (
        <Chip
            label={label}
            size="small"
            sx={{
                ...({ typography: 'overline' } as const),
                bgcolor,
                color,
                border,
                borderColor,
                borderRadius: 1,
                height: 24,
                px: 1,
                maxWidth: 80,
                marginRight: 1,
            }}
        />
    );
}
